import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { selectConfigItem, setConfigItem } from "@/features/config/configSlice";

import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { RTL_LANGUAGES } from "@/features/app/constants";
import type { SupportedLanguage } from "@/features/config/types";
import { initializeHandleRTLText } from "@/features/map/layers/utils";

const useLanguage: React.FC<void> = () => {
  const rtl = useAppSelector(selectConfigItem("ui.rtl"));
  const { i18n } = useTranslation();
  const lang = useAppSelector(selectConfigItem("i18n.language"));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!i18n.isInitialized) return;
    dispatch(
      setConfigItem(
        "i18n.language",
        i18n.resolvedLanguage as SupportedLanguage,
      ),
    );
  }, [i18n.isInitialized]);

  useEffect(() => {
    initializeHandleRTLText();
    if (rtl === true) {
      document.querySelector("html")?.setAttribute("dir", "rtl");
    } else {
      document.querySelector("html")?.removeAttribute("dir");
    }
  }, [rtl]);

  useEffect(() => {
    if (!lang) return;

    document.querySelector("html")?.setAttribute("lang", lang);

    i18n.changeLanguage(lang);

    dispatch(
      setConfigItem(
        "ui.rtl",
        RTL_LANGUAGES.filter((rltLanguage) => lang.startsWith(rltLanguage))
          .length > 0,
      ),
    );
  }, [lang]);

  return <></>;
};

export default useLanguage;
